// import axios from 'axios';

export default {
  getDefaultLanguage: ({ commit }, payload) => {
    commit('mutateDefaultLanguage', payload);
  },

  setDefaultLanguage: ({ commit }, languageCode) => {
    commit('mutateDefaultLanguage', languageCode);
  },

  openNavDrawer: ({ commit }) => {
    commit('mutateNavDrawer');
  },

  checkIfProfileImpersonating: ({ commit }, payload) => {
    commit('mutateProfileImpersonating', payload);
  }
};
